import { render, staticRenderFns } from "./PositionSection.vue?vue&type=template&id=8d5cf9a2&"
import script from "./PositionSection.vue?vue&type=script&lang=js&"
export * from "./PositionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports